angular
  .module(__filename, [
    // vendor modules
    'ui.router',
    'xeditable',
    'ngAnimate',
    'ngSanitize',

    // local modules
    require('goodeggs-ops-angular-modules/config/ui_router'),

    require('./confirm').default,
    require('./whoops').default,

    require('goodeggs-purchase-orders-sdk/catalog/angular_resource'),
    require('goodeggs-purchase-orders-sdk/line_item/angular_resource'),
    require('goodeggs-purchase-orders-sdk/purchase_order/angular_resource'),
    require('goodeggs-purchase-orders-sdk/order_summary_email/angular_resource'),
  ])

  .config(
    ngInject(($stateProvider) =>
      $stateProvider.state('public', {
        abstract: true,
        url: '/public',
        template: require('./template'),
        controller: require('./controller').default,
        bypassAuth: true,
      }),
    ),
  );

export default __filename;
